import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SwipeableDrawer,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import { IoMdLogOut } from "react-icons/io";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Banner } from "../../assets/images";
import { isIOS } from "../../config/constants/devices";
import APP_LIST from "../../config/constants/routes";
import SOCIALS from "../../config/constants/socials";
import { dispatchUserLogout } from "../../config/redux/actions";
import { selectUserData } from "../../config/redux/slices/userSlice/selectors";
import { removeAuthToken } from "../../utils/auth";
import {
  StyledAvatar,
  StyledBanner,
  StyledDarkThemeContainer,
  StyledFooter,
  StyledLogoutIcon,
  StyledNavigation,
  StyledProfileContainer,
  StyledProfileDetails,
  StyledSidebar,
  StyledSidebarIcon,
  StyledSocialIconWrapper,
  StyledSocialsContainer,
} from "./styles";
import useThemeContext from "../../config/contexts/ThemeContext";

const Sidebar = ({ show, toggleSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const userDataState = useSelector(selectUserData);
  const { isDarkMode, toggleTheme } = useThemeContext();
  const userData = userDataState.data;
  const avatar =
    userData.firstName.substring(0, 1) + userData.lastName.substring(0, 1);

  const handleNavigate = (path) => {
    navigate(path, { replace: true });
    toggleSidebar();
  };

  const handleSocialClick = (url) => {
    window.open(url, "_blank");
  };

  const navigateToHome = () => {
    navigate("/");
    toggleSidebar();
  };

  const handleLogout = () => {
    dispatchUserLogout();
    removeAuthToken();
  };

  const onProfileClick = () => {
    navigate("/app/profile");
    toggleSidebar();
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={show}
      onOpen={() => {}}
      onClose={toggleSidebar}
      disableBackdropTransition={isIOS}
      disableDiscovery={isIOS}
    >
      <StyledSidebar>
        <StyledNavigation>
          <StyledBanner src={Banner} onClick={navigateToHome} />
          <List>
            {APP_LIST.filter((app) => !app.hide).map((app) => (
              <ListItem
                key={app.name}
                onClick={() => handleNavigate(app.path)}
                disablePadding
              >
                <ListItemButton selected={location.pathname.includes(app.path)}>
                  <ListItemIcon>
                    <StyledSidebarIcon src={app.icon} />
                  </ListItemIcon>
                  <ListItemText primary={app.name} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </StyledNavigation>
        <StyledFooter>
          <Divider />
          <StyledProfileContainer>
            <StyledProfileDetails onClick={onProfileClick}>
              <StyledAvatar>
                <Typography fontWeight="bold">{avatar}</Typography>
              </StyledAvatar>
              <Typography variant="body1" fontWeight="medium">
                {userData.firstName} {userData.lastName}
              </Typography>
            </StyledProfileDetails>
            <Tooltip title="Logout" placement="top">
              <StyledLogoutIcon onClick={handleLogout}>
                <IoMdLogOut size="35px" fontWeight="100" />
              </StyledLogoutIcon>
            </Tooltip>
          </StyledProfileContainer>
          <Divider />
          <StyledDarkThemeContainer>
            <Typography variant="body1">Dark Mode</Typography>
            <Switch
              color="primary"
              checked={isDarkMode}
              onChange={toggleTheme}
            />
          </StyledDarkThemeContainer>
          <Divider />
          <StyledSocialsContainer>
            {SOCIALS.map((social) => (
              <Tooltip title={social.name} key={social.name}>
                <StyledSocialIconWrapper
                  onClick={() => handleSocialClick(social.url)}
                >
                  <social.icon fontSize={24} />
                </StyledSocialIconWrapper>
              </Tooltip>
            ))}
          </StyledSocialsContainer>
        </StyledFooter>
      </StyledSidebar>
    </SwipeableDrawer>
  );
};

export default Sidebar;
